module.exports = __webpack_public_path__ + "media/photos/term-bg-6-bdafce62.jpg";